import React, { useState } from "react";
import { Button, Form, Grid, Header, Message, Segment } from 'semantic-ui-react';
import { useAuth } from "../../../lib/auth/useAuth";
import mustardBg from '../../../img/mustarddreams.png';
import MenuTopBar from "../../../components/Menu/MenuTopBar";
import { Link } from "react-router-dom";
import './Signup.css';

function Signup(props) {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validationError, setValidationError] = useState("");
  const [serverErrors, setServerErrors] = useState({});
  const auth = useAuth();

  const handleSubmit = async () => {
    setValidationError("");
    setServerErrors({});

    if (!username || !email || !password) {
      setValidationError("All fields are required.");
      return;
    }
    if (password.length < 8) {
      setValidationError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setValidationError("Passwords do not match.");
      return;
    }

    const result = await auth.signup(username, email, password);
    if (result.success) {
      window.location.href = '/';
    } else {
      setServerErrors(result.errors || {});
    }
  };

  const formatErrors = () => {
    const messages = [];
    if (serverErrors.username) messages.push(`Username: ${serverErrors.username.join(', ')}`);
    if (serverErrors.email) messages.push(`Email: ${serverErrors.email.join(', ')}`);
    if (serverErrors.password) messages.push(`Password: ${serverErrors.password.join(', ')}`);
    return messages;
  };

  return (
    <div id="signup-page">
      <div id="dashboard">
        <MenuTopBar />
      </div>
      <img
        style={{ minWidth: '600px', width: '100%', height: '100%', position: 'absolute', left: '0', top: '20px' }}
        src={mustardBg}
        alt="background"
      />
      <Grid textAlign="center" style={{ height: '100vh' }} verticalAlign="middle">
        <Grid.Column style={{ maxWidth: 450 }}>
          <Header as="h2" className="white-text" textAlign="center">
            Create your account
          </Header>
          <Form size="large" className="signup-form" onSubmit={handleSubmit}>
            <Segment basic stacked className="signup-form">
              <Form.Input
                fluid
                icon="user"
                iconPosition="left"
                placeholder="Username"
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
              <Form.Input
                fluid
                icon="mail"
                iconPosition="left"
                placeholder="Email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Password (min 8 characters)"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Confirm Password"
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
              />
              {validationError && (
                <Message error visible header="Validation Error" content={validationError} />
              )}
              {Object.keys(serverErrors).length > 0 && (
                <Message error visible header="Registration Failed" list={formatErrors()} />
              )}
              <Button className="signup-btn" color="yellow" fluid size="large" type="submit">
                Sign Up
              </Button>
            </Segment>
          </Form>
          <Message className="login-link-message">
            Already have an account? <Link to="/login">Login</Link>
          </Message>
        </Grid.Column>
      </Grid>
    </div>
  );
}

export default Signup;
